var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"absolute z-10 border border-b-transparent border-l-gray-300 border-r-transparent border-t-gray-300 bg-white",style:(_setup.arrowStyles)})
}
var staticRenderFns = []

export { render, staticRenderFns }